<template>
  <div class="OrderService">
    <ld-header>
      购票须知
    </ld-header>

    <div class="OrderServiceWarpper">
      <mescroll-vue
        :down="down"
      >
        <div
          class="content"
          v-for="rule in ruleList"
          :key="rule.cName"
        >
          <van-divider>{{ rule.cName }}</van-divider>
          <van-row
            v-for="(val, key) in rule"
            :key="key"
            v-show="key.indexOf('by') > -1"
          >
            <van-col
              offset="2"
              span="20"
            >
              {{ val }}
            </van-col>
          </van-row>
        </div>
      </mescroll-vue>
    </div>
  </div>
</template>

<script>
import { Divider } from 'vant'

export default {
  name: 'OrderService',
  components: {
    [Divider.name]: Divider,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
  },
  data () {
    return {
      ruleList: [],
      down: { use: false }
    }
  },
  created () {
    this.getRule()
  },
  methods: {
    // 获取退改签 规则
    getRule () {
      this.$api['common/getBClass']({parNo: 150}).then(res => {
        this.ruleList = res.data.list
      })
    }
  }
}
</script>

<style lang="less" scoped>
.OrderService {
  .content {
    padding: 30px 0;
  }
  .OrderServiceWarpper{
    height: calc(100vh - 46px);
    overflow: hidden;
  }
}
</style>